import _taggedTemplateLiteral from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/taggedTemplateLiteral.js";
import _asyncToGenerator from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
var _templateObject, _templateObject2;
var __jsx = React.createElement;
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
import React from 'react';
import styled, { css } from 'styled-components';
import Link from '@/components/atoms/Link';
import withMatch from '@/hocs/withMatch';
import { connect } from 'react-redux';
import { colorPalette, fonts } from '../../../styles/styleGuide';
import getLinkFromPageObject from '../../../services/getLinkFromPageObject';
import ButtonSecondary from '../buttons/ButtonSecondary';
import ButtonPrimary from '../buttons/ButtonPrimary';
import { darken } from './../../../styles/utils';
import { getResultData } from '../../../redux/apiData';
import get from 'lodash.get';
import { useDispatch } from 'react-redux';
import { performApiRequest } from '@/redux/apiData';
var mapStateToProps = function mapStateToProps(state, ownProps) {
  return {
    styling: get(getResultData(state.apiData, 'getSettings', {
      projectSlug: String(ownProps.match.params.projectSlug),
      env: String(ownProps.match.params.env)
    }), 'styling', {})
  };
};
var PageLinkInternal = function PageLinkInternal(_ref) {
  var pageId = _ref.pageId,
    type = _ref.type,
    pages = _ref.pages,
    match = _ref.match,
    styling = _ref.styling,
    content = _ref.content,
    clickHandler = _ref.clickHandler;
  var dispatch = useDispatch();
  if (!pages) {
    return null;
  }
  var pageLink = pageId && pages && pages[pageId] ? "/".concat(getLinkFromPageObject(pages[pageId])) : undefined;
  if (!pageLink) {
    return null;
  }

  // BAMECW-4157: Post analytics request if type is 'skip'
  var pageLinkInternalClickHandler = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
      return _regenerator().w(function (_context) {
        while (1) {
          switch (_context.n) {
            case 0:
              _context.n = 1;
              return dispatch(performApiRequest('postFAQFeedback', {}, {
                id: 0,
                action: 'open'
              }));
            case 1:
              return _context.a(2);
          }
        }
      }, _callee);
    }));
    return function pageLinkInternalClickHandler() {
      return _ref2.apply(this, arguments);
    };
  }();
  var _ref3 = match.params.env === 'closed' ? {
      button: colorPalette.blue
    } : styling,
    color = _ref3.button;
  switch (type) {
    case 'link':
      return __jsx(StyledLink, {
        href: pageLink,
        color: color,
        "data-id": "richText_PageLinkInternal_StyledLink"
      }, content);
    case 'skip':
      return __jsx(ButtonPrimary, {
        route: pageLink,
        label: content,
        type: "internalLink",
        clickHandler: pageLinkInternalClickHandler,
        "data-id": "richText_PageLinkInternal_ButtonPrimary"
      });
    case 'primaryButton':
      return __jsx(ButtonPrimary, {
        route: pageLink,
        label: content,
        type: "internalLink",
        clickHandler: clickHandler !== null && clickHandler !== void 0 ? clickHandler : null,
        "data-id": "richText_PageLinkInternal_ButtonPrimary_2"
      });
    case 'secondaryButton':
    default:
      return __jsx(ButtonSecondary, {
        route: pageLink,
        label: content,
        type: "internalLink",
        clickHandler: clickHandler,
        "data-id": "richText_PageLinkInternal_ButtonSecondary"
      });
  }
};
export default withMatch(connect(mapStateToProps)(PageLinkInternal));
export var LinkStyles = css(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  font-family: ", ";\n  text-decoration: none;\n  color: ", ";\n  border-bottom: 1rem solid transparent;\n  transition: color 0.2s ease-in-out, border-bottom 0.2s ease-in-out;\n\n  &:hover {\n    color: ", ";\n    border-bottom: 1rem solid\n      ", ";\n  }\n"])), fonts.primary, function (props) {
  return props.color ? props.color : colorPalette.blue;
}, function (props) {
  return props.color ? darken(props.color, 15) : colorPalette.darkBlue;
}, function (props) {
  return props.color ? darken(props.color, 15) : colorPalette.darkBlue;
});
var StyledLink = styled(Link)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  ", ";\n"])), LinkStyles);